import { useQuery } from "@tanstack/react-query";
import { getDashboardCASProduction } from "../../../repositories/ProductionRepository";
import type { CASProcessByShift } from "../../../models/ProcessByShift";

export const useCASProductionQuery = (
  startDate: Date | null,
  endDate: Date | null,
) => {
  return useQuery({
    queryKey: [
      "dashboard-cas-production",
      startDate?.toISOString(),
      endDate?.toISOString(),
    ],
    queryFn: async ({ signal }) => {
      const resp = await getDashboardCASProduction(startDate, endDate, signal);
      if (resp.ok) {
        return (resp.data?.tables[0].rows as CASProcessByShift[]) ?? [];
      }
      throw new Error(resp.message ?? "Failed to fetch CAS production");
    },
    enabled: !!startDate && !!endDate,
  });
};
